import { cn } from "@/lib/utils";

export const adminOverlay = (z = "z-50") =>
  cn(
    "fixed inset-0 flex items-center justify-center p-4 max-lg:p-0 bg-[var(--admin-scrim)]",
    z,
  );

export const adminDialogPanel = (maxWidth = "max-w-3xl") =>
  cn(
    "admin-glass-elevated admin-dialog-sheet w-full overflow-y-auto max-h-[90vh]",
    "max-lg:max-h-none max-lg:h-[100dvh] max-lg:rounded-none",
    maxWidth,
    "max-lg:max-w-none",
  );

export const adminIconBtn =
  "inline-flex items-center justify-center min-h-11 min-w-11 rounded-admin-sm p-2 text-white/70 hover:text-white hover:bg-white/10 transition-colors";

export const adminInput =
  "admin-field px-4 py-3 font-['Manrope'] focus:outline-none";
